<div *ngIf="selectedSubMenus && selectedSubMenus.length" [wbo-css-var]="{'--colNum': (model.numOfColumns$ | async)}"
     class="subMenuHeader">
    <div *ngIf="hasPrev" class="paging-button">
        <wbo-screen-layout-button (click)="prevPage()" [icon]="'chevron-left'"></wbo-screen-layout-button>
    </div>
    <div (click)="model.popAllSelectSubMenu()" *ngIf="!hasPrev" class="subMenuHeader-button">
        {{'wbo.screen-layout.common.home' | translate}}
    </div>
    <div (click)="model.popSelectSubMenuTo(i)" *ngFor="let i of page" [ngClass]="{'selected': i === model.selectedItem}" class="subMenuHeader-button">
        {{i.displayName}}
    </div>
    <div *ngIf="hasNext" class="subMenuHeader-paging-button">
        <wbo-screen-layout-button (click)="nextPage()" [icon]="'chevron-right'"></wbo-screen-layout-button>
    </div>
</div>
